/**
 * @module app.shared
 */

import { IApiRequest } from 'app/shared/lib/api/api-types';

interface IStoredObjectInternals {
    tenant: string | null;
    store: string | null;
    url: string | null;
}

export class ApiStoredObject implements IApiRequest {

    public body: Object | null = null;

    private readonly internals: IStoredObjectInternals = {
        tenant: null,
        store: null,
        url: null
    };

    /**
     * Construct a new API Stored Object Request
     *
     * **Note**: `api.storedObject()` is a shortcut to constructing this object
     * @param url the API URL for which to load settings
     */
    constructor(store: string, url: string, body?: Object) {
        this.internals.store = store;
        this.internals.url = url;
        this.body = body || null;
    }

    /** Returns `true` if this settings request has a tenant code value specified */
    public hasTenant(): boolean {
        return !!this.internals.tenant;
    }

    /**
     * Specify the tenant code to use for this settings request
     * @param tenant the tenant code to settings request, or `null` to use the currently logged in tenant
     */
    public withTenant(tenant: string | null): this {
        this.internals.tenant = tenant;
        return this;
    }

    /**
     * Override the URL used to make this settings request
     * @param url the new URL to settings request against
     */
    public overrideUrl(url: string): this {
        this.internals.url = url;
        return this;
    }

    /**
     * Convert the current settings request to an API URL
     */
    public toString(): string {
        if(!this.internals.url) {
            return '';
        }

        const url = this.internals.tenant ? `${encodeURI(this.internals.tenant)}/store/${this.internals.store}/${this.internals.url}` : this.internals.url;
        return url;
        // in case query-strings are needed in the future
        // const query: string[] = [];
        // return (query.length > 0 ? (`${url}?${query.join('&')}`) : url);
    }

}
